module.exports = __webpack_public_path__ + "static/img/scene10.372e84f5.png";